import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import { Currencies, FormType } from '../../shared/models/form';

const Currency = () => {
  const { control } = useFormContext<FormType>();
  const { t } = useTranslation();
  const {
    field: { onChange, onBlur, value, ref, name },
  } = useController({ control, name: 'currency', rules: { required: true } });

  return (
    <div className="md:w-36">
      <label htmlFor="currency" className="text-sm mb-2 block px-2">
        {t('Currency')}
      </label>
      <select
        id="currency"
        className="form-select w-full h-12 rounded bg-white border-1 border-input-gray px-4 focus:ring-2 focus:ring-gray-500 focus:border-gray-500 focus:outline-offset-0"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        ref={ref}
        name={name}
      >
        <option value={Currencies.thb}>{t('Baht')}</option>
        <option value={Currencies.usd}>{t('Dollar')}</option>
        <option value={Currencies.cny}>{t('Yuan')}</option>
        <option value={Currencies.inr}>{t('Rupee')}</option>
      </select>
    </div>
  );
};

export default Currency;
